import { useSyncExternalStore } from 'react';

// Guarded so tests (jsdom has no matchMedia) and non-browser contexts degrade
// to "motion allowed = false → not reduced" without throwing.
const query = (): MediaQueryList | null =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : null;

function subscribe(callback: () => void): () => void {
  const mq = query();
  if (!mq) return () => {};
  mq.addEventListener('change', callback);
  return () => mq.removeEventListener('change', callback);
}

/**
 * True when the user has asked the OS for reduced motion. Reactive. Use it to
 * skip expensive/decorative JS animations (canvas loops, waveforms); CSS
 * animations are better gated with Tailwind's `motion-reduce:` variant.
 */
export function useReducedMotion(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => query()?.matches ?? false,
    () => false,
  );
}
